<template>
  <LayoutBasic>
    <template v-slot:title>
      <v-list-item @click="$router.push('/')" class="hoverable">
        <v-list-item-icon>
          <v-icon large>mdi-view-dashboard</v-icon>
          <!-- ícono tipo "módulos" -->
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="title font-weight-bold"
            >Inicio</v-list-item-title
          >
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
    </template>

    <template v-slot:navigation-title>Productos</template>

    <template v-slot:vista-previa>
      <v-row align="center" justify="center" class="mt-2 mx-auto">
        <v-col cols="12" class="px-0 px-sm-3">
          <v-container class="pa-0 pa-sm-3">
            <router-view></router-view>
          </v-container>
        </v-col>
      </v-row>
    </template>
  </LayoutBasic>
</template>

<script>
import LayoutBasic from "@/layouts/LayoutBasic.vue";

export default {
  name: "ProductosEmpresaLayout",
  components: { LayoutBasic },
};
</script>
